import { useClientQueries } from '@zenstackhq/tanstack-query/react';
import { schema } from '../__generated__/schema-lite';

type ModelName = keyof typeof schema.models;

type CreateMutation = {
  mutateAsync: (args: { data: Record<string, unknown> }) => Promise<unknown>;
  isPending: boolean;
};
type UpdateMutation = {
  mutateAsync: (args: {
    where: Record<string, unknown>;
    data: Record<string, unknown>;
  }) => Promise<unknown>;
  isPending: boolean;
};

/** Generic create+update for a model — write-side mirror of useResourceQuery.
 *  Mutations re-throw on failure (CLAUDE.md convention). Cache invalidation is
 *  handled by zenstack's mutation hooks automatically. */
export function useResourceMutation<M extends ModelName>(modelName: M) {
  const crud = useClientQueries(schema);
  const modelKey = (modelName as string).charAt(0).toLowerCase() + (modelName as string).slice(1);
  const ops = (
    crud as unknown as Record<
      string,
      { useCreate: () => CreateMutation; useUpdate: () => UpdateMutation }
    >
  )[modelKey]!;
  return { create: ops.useCreate(), update: ops.useUpdate() };
}
